import { useMediaQuery } from "@mui/material";
import { employeeRequests } from "api/employeeApi";
import { erasmusRequests } from "api/erasmusApi";
import { settings } from "app";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { MobileListRow } from "features/MobileListRow";
import {
  BooleanField,
  Datagrid,
  EditButton,
  List,
  ListActions,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  SimpleList,
  TextField,
} from "react-admin";
import ProfessorField from "server/components/Fields/ProfessorField";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListFilters = [
  <ReferenceInput
    source="mobilityVisitType"
    reference={erasmusRequests.getMobilityTypesSelect()}
    alwaysOn
  >
    <SelectInput
      label="Тип визита"
      optionText="nameBg"
    />
  </ReferenceInput>,
];

const ListErasmusOutgoingTeachers = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  return (
    <List
      filters={ListFilters}
      sx={settings.style.blockStyle}
      exporter={false}
      actions={
        <ListActions hasCreate={checkPermission(userPermissions, permissions.canManageErasmusOutgoingTeachers)} />
      }
      title="Заминаващи преподаватели"
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={() => (
            <MobileListRow
              fields={[
                {
                  label: "Преподавател",
                  value: (
                    <ReferenceField
                      source="employeeId"
                      reference={employeeRequests.getEmployeesSelect()}
                    >
                      <TextField source="fullName" />
                    </ReferenceField>
                  ),
                },
              ]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "ID", value: record?.id }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Университет",
                    value: <TextField source="universityName" />,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Тип визита",
                    value: (
                      <ReferenceField
                        source="mobilityVisitType"
                        reference={erasmusRequests.getMobilityTypesSelect()}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <div>
              <MobileListRow fields={[{ label: "Приключил", value: <BooleanField source="isCompleted" /> }]} />
              <SecuredComponent permission={permissions.canManageErasmusOutgoingTeachers}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewErasmusOutgoingTeachers}>
                <ShowButton label="" />
              </SecuredComponent>
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="id"
            label="ID"
            sortable={false}
          />
          <ProfessorField
            source="employeeId"
            sortable={false}
          />
          <TextField
            label="Университет"
            source="universityName"
            sortable={false}
          />
          <ReferenceField
            label="Тип визита"
            source="mobilityVisitType"
            reference={erasmusRequests.getMobilityTypesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <BooleanField
            source="isCompleted"
            label="Приключил"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canManageErasmusOutgoingTeachers}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewErasmusOutgoingTeachers}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListErasmusOutgoingTeachers;
